import { CustomOptionOfferResponseDTO, StandardPartOfferResponseDTO } from '@luminovo/api-contracts';
import { extractAmountFromMonetaryValue, isPresent, MonetaryValue, QuantityHelper } from '@luminovo/commons';

import { Solution } from '../../types';

export function extractMoq({
    solution,
}: {
    solution: Pick<Solution, 'offerIdAndSignature' | 'unit'> | undefined;
}): number | undefined {
    if (!isPresent(solution)) {
        return undefined;
    }

    const signature = solution.offerIdAndSignature.signature;
    if (signature && 'moq' in signature) {
        return QuantityHelper.from(solution.unit).scale(signature.moq).normalize().parseValue();
    }
    return undefined;
}

export function extractMoqFromOffer(
    unitPriceOriginal: MonetaryValue | null,
    offer: StandardPartOfferResponseDTO,
): number | undefined {
    const matchingPriceBreak = offer.price_breaks.find(
        (priceBreak) =>
            extractAmountFromMonetaryValue(priceBreak.unit_price) ===
                extractAmountFromMonetaryValue(unitPriceOriginal) &&
            unitPriceOriginal?.currency === priceBreak.unit_price.currency,
    );

    return matchingPriceBreak?.minimum_order_quantity;
}

export function extractMoqFromCustomOptionOffer(
    unitPriceOriginal: MonetaryValue | null,
    offer: CustomOptionOfferResponseDTO,
): number | undefined {
    const matchingPriceBreak = offer.price_breaks.find(
        (priceBreak) =>
            extractAmountFromMonetaryValue(priceBreak.unit_price) ===
                extractAmountFromMonetaryValue(unitPriceOriginal) &&
            unitPriceOriginal?.currency === priceBreak.unit_price.currency,
    );

    if (matchingPriceBreak === undefined) {
        return undefined;
    }

    return QuantityHelper.from(offer.unit_of_measurement)
        .scale(matchingPriceBreak.minimum_order_quantity)
        .normalize()
        .parseValue();
}
